import { render, staticRenderFns } from "./PolizasAdministracionForm.vue?vue&type=template&id=5f501f80&scoped=true&"
import script from "./PolizasAdministracionForm.vue?vue&type=script&lang=js&"
export * from "./PolizasAdministracionForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasAdministracionForm.vue?vue&type=style&index=0&id=5f501f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f501f80",
  null
  
)

export default component.exports